<template>
  <div>
    <slot name="navigation"/>
    <div class="container-fluid app-container p-0 m-0">
      <slot name="content" />
    </div>

    <footer class="d-flex justify-content-between align-items-center">
      <div
        class="container d-flex justify-content-between align-items-center px-md-0"
      >
        <h5>&#169; Startups Portal 2021</h5>
        <div class="icons">
          <img src="../../public/assets/images/twitter.svg" alt />
          <img src="../../public/assets/images/insta.svg" alt />
          <img
            class="fbook"
            src="../../public/assets/images/facebook.svg"
            alt
          />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  width: 100%;
  background: black;
  color: white;
  height: 10vh;
}

footer > div {
  width: 100%;
}

footer > div h5 {
  font-size: 1em;
}

.icons > img {
  margin-left: 1rem;
}

.app-container {
  min-height: 100vh;
}
</style>
